var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSv = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_634_1510",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.175 36.2242C29.7651 36.2242 38.35 28.1151 38.35 18.1121C38.35 8.10906 29.7651 0 19.175 0C8.58494 0 0 8.10906 0 18.1121C0 28.1151 8.58494 36.2242 19.175 36.2242Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_634_1510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9.53125 14.4897H9.64375V0H-9.53125V14.4897ZM-9.53125 36.2242H9.64375V21.7345H-9.53125V36.2242ZM17.3137 36.2242H51.8287V21.7345H17.3137V36.2242ZM17.3137 0V14.4897H51.8287V0H17.3137Z",
    fill: "#006AA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3137 0H9.64375V14.4897H-9.53125V21.7345H9.64375V36.2242H17.3137V21.7345H51.8287V14.4897H17.3137V0Z",
    fill: "#FECC00"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSv);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Sv.bc7d874c0e90db7cbbb6283fd8516157.svg";